
        import { aplicarConfiguracoesSeguranca } from '/src/js/utils/securityConfig.js';
        aplicarConfiguracoesSeguranca();
    